import React from 'react';

const ChairIcon = ({ id, className, color, styles = {} }) => {
	const colorMap = {
		cdgr: '#5B5855',
		cgrn: '#0C4A34',
		cw: '#FFFFFF',
		cbb: '#3477ac',
	};

	return (
		<div id={id} className={className} style={styles}>
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.42318 9.09561L5.92878 5.94536C6.20117 4.24819 7.66566 3 9.38456 3H14.619C16.3379 3 17.8024 4.24819 18.0748 5.94536L18.5804 9.09561C19.1413 8.85502 19.9049 8.70909 20.7053 9.1344C21.8986 9.7685 22.3443 11.2462 21.7254 12.4335L20.4804 14.8217C19.8244 16.0801 18.6482 16.962 17.2927 17.2497L18.6608 20.4727C18.8226 20.854 18.6457 21.2964 18.2655 21.4609C17.8854 21.6254 17.446 21.4496 17.2841 21.0684L16.4083 19.005H7.42261L6.7417 21.1951C6.61864 21.5909 6.19914 21.81 5.80472 21.6844C5.4103 21.5588 5.19032 21.1362 5.31338 20.7403L6.42082 17.1784C5.18856 16.833 4.13191 15.9894 3.52319 14.8217L2.27823 12.4335C1.65926 11.2462 2.10497 9.7685 3.29828 9.1344C4.09866 8.70909 4.86232 8.85502 5.42318 9.09561ZM7.93676 17.3513H15.7063L15.7715 17.505L7.88897 17.505L7.93676 17.3513ZM5.26766 10.7217C4.84244 10.4272 4.3984 10.2484 4.00215 10.459C3.543 10.703 3.36668 11.2766 3.60834 11.7401L4.8533 14.1283C5.40566 15.1879 6.494 15.8513 7.67995 15.8513H16.3237C17.5096 15.8513 18.5979 15.1879 19.1503 14.1283L20.3953 11.7401C20.6369 11.2766 20.4606 10.703 20.0015 10.459C19.6052 10.2484 19.1612 10.4272 18.7359 10.7217C18.1246 11.1453 17.3488 10.8874 17.231 10.1531L16.5938 6.18307C16.4381 5.21325 15.6013 4.5 14.619 4.5H9.38456C8.40233 4.5 7.56548 5.21325 7.40983 6.18306L6.77266 10.1531C6.6548 10.8874 5.879 11.1453 5.26766 10.7217ZM16.9294 12.3002C13.8866 11.5323 10.3577 11.5364 6.84432 12.2963C6.57442 12.3547 6.40295 12.6209 6.46133 12.8908C6.51972 13.1607 6.78584 13.3321 7.05574 13.2737C10.4422 12.5412 13.8132 12.5451 16.6846 13.2698C16.9524 13.3374 17.2242 13.1752 17.2918 12.9074C17.3594 12.6397 17.1971 12.3678 16.9294 12.3002Z'
					fill={`${colorMap[color] || '#B0ACA3'}`}
				/>
			</svg>
		</div>
	);
};

export default ChairIcon;
